import { api } from "./client";

export interface Department {
  name: string;
  unit?: string | null;
  is_common?: boolean;
}

type RawResponse =
  | Department[]
  | { departments?: unknown; results?: unknown; items?: unknown }
  | Record<string, unknown>;

function coerce(raw: unknown): Department[] {
  if (Array.isArray(raw)) return raw as Department[];
  if (raw && typeof raw === "object") {
    const obj = raw as Record<string, unknown>;
    for (const key of ["departments", "results", "items", "data"]) {
      const candidate = obj[key];
      if (Array.isArray(candidate)) return candidate as Department[];
    }
  }
  return [];
}

export async function getDepartments(): Promise<Department[]> {
  const { data } = await api.get<RawResponse>("/departments/");
  return coerce(data);
}

// Display-only overrides for backend-side typos. The stored value
// (and therefore everything the API sees on read/write) stays
// untouched — only the label rendered to users gets corrected. Keep
// this list short; backend should be the long-term source of truth.
// Apply via `displayDepartment(name)` at every rendering boundary.
const DEPARTMENT_DISPLAY_OVERRIDES: Readonly<Record<string, string>> = {
  Adminstration: "Administration",
};

export function displayDepartment(
  name: string | null | undefined,
): string {
  if (!name) return "";
  return DEPARTMENT_DISPLAY_OVERRIDES[name] ?? name;
}
